export default "__VITE_ASSET__CvG0PrQ9__"